import { Box, IconButton, Tooltip, useTheme } from "@mui/material"
import { SelectionOptions } from "../../shared/SelectionOptions"
import { useLocation, useNavigate } from "react-router-dom";
import { scheduleRoutes, scheduleRoutesCombined } from "../ScheduleNavigation";
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

interface ScheduleCommonActionsProps {
    eventId: number;
}

export const ScheduleCommonActions = ({
    eventId
}: ScheduleCommonActionsProps) => {

    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();

    const winLocation = scheduleRoutesCombined.win_eventMatch.replace(scheduleRoutes.match, eventId.toString());
    const isWinPage = location.pathname === winLocation;

    const categoryCodeItems = [
        { key: 'WIN', value: 'Win' },
        { key: 'DER', value: 'Derivs' }
    ]

    const handleCategoryChange = (categoryCode: string) => {
        const subPath = categoryCode === categoryCodeItems[0].key ?
            scheduleRoutes.win :
            scheduleRoutes.derivs;
        navigate(`${scheduleRoutes.root}/${subPath}${eventId}${location.search}`);
    }

    const handleScheduleNavigate = () => {
        navigate(`${scheduleRoutesCombined.main}${location.search}`);
    }

    return (
        <>
            <Box>
                <Box sx={{margin:'-3px -10px 0 -4px'}}>
                    <Tooltip title='Return to schedule page' arrow>
                        <IconButton
                            id='win-derivs-schedule'
                            aria-label='win-derivs-schedule'
                            sx={{ margin: 0, padding: '4px 10px 0 0 ', color: theme.palette.background.paper }}
                            onClick={handleScheduleNavigate}
                        >
                            <ArrowCircleLeftIcon
                                sx={{ fontSize: '34px' }}
                            />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
            <Box>
                <SelectionOptions
                    id="schedule-actions-categories"
                    items={categoryCodeItems}
                    value={categoryCodeItems[isWinPage ? 0 : 1].key}
                    onValueChange={handleCategoryChange}
                />
            </Box>
        </>
    )
}
